window.quizResults = {

  dry: {

    title: "Dry Skin",

    confidence: 94,

    description:
      "Your skin naturally produces less oil than average and benefits from consistent hydration and barrier support.",

    characteristics: [
      "Often feels tight after cleansing",
      "Can appear dull",
      "Small, less visible pores",
      "May develop dry patches"
    ],

    dailyAdvice: [
      "Use a gentle cleanser",
      "Apply moisturizer morning and evening",
      "Avoid very hot water",
      "Support your skin barrier consistently"
    ],

    commonMistakes: [
      "Over-cleansing",
      "Skipping moisturizer",
      "Using harsh exfoliants too often"
    ],

     profile:{

hydration:95,

barrier:90,

oilBalance:30,

sensitivity:80

},

    recommendation: {

      recommended: true,

      product: "Genessence",

      button: "View Genessence",

      url: "/products/genessence",

      reason:
        "Your answers indicate that additional nourishment and barrier support may benefit your skin."

    }

  },

  normal: {

    title: "Normal Skin",

    confidence: 91,

    description:
      "Your skin appears well balanced, with healthy oil production and few ongoing concerns.",

    characteristics: [
      "Comfortable throughout the day",
      "Balanced hydration",
      "Few blemishes",
      "Healthy-looking complexion"
    ],

    dailyAdvice: [
      "Keep your routine simple",
      "Stay consistent",
      "Protect your skin with SPF",
      "Maintain hydration"
    ],

    commonMistakes: [
      "Changing products too frequently",
      "Over-exfoliating",
      "Skipping sunscreen"
    ],

    profile:{

hydration:80,

barrier:88,

oilBalance:85,

sensitivity:35

},

    recommendation: {

      recommended: false,

      title: "No face oil required",

      reason:
        "Your skin already appears balanced. A consistent cleanser, moisturizer and SPF routine is likely all you need right now."

    }

  },

  combination: {

    title: "Combination Skin",

    confidence: 93,

    description:
      "Different areas of your face have different needs, typically an oilier T-zone with drier or balanced cheeks.",

    characteristics: [
      "Oilier forehead and nose",
      "Normal or dry cheeks",
      "Occasional congestion",
      "Seasonal variation"
    ],

    dailyAdvice: [
      "Avoid overly stripping cleansers",
      "Hydrate consistently",
      "Use lightweight products",
      "Support your skin barrier"
    ],

    commonMistakes: [
      "Treating the whole face as oily",
      "Using drying alcohols",
      "Skipping hydration"
    ],

    profile:{

hydration:75,

barrier:80,

oilBalance:60,

sensitivity:45

},

    recommendation: {

      recommended: true,

      product: "Genessence",

      button: "View Genessence",

      url: "/products/genessence",

      reason:
        "A lightweight facial oil can help maintain balance without leaving the skin feeling heavy."

    }

  },

  oily: {

    title: "Oily Skin",

    confidence: 90,

    description:
      "Your skin naturally produces more sebum than average, which can increase shine and congestion.",

    characteristics: [
      "Visible shine",
      "Larger pores",
      "More frequent congestion",
      "Oil throughout the day"
    ],

    dailyAdvice: [
      "Use a gentle cleanser",
      "Avoid over-cleansing",
      "Choose lightweight hydration",
      "Don't strip your skin"
    ],

    commonMistakes: [
      "Trying to dry out the skin",
      "Skipping moisturizer",
      "Using harsh cleansers"
    ],

    profile:{

hydration:55,

barrier:70,

oilBalance:95,

sensitivity:30

},

    recommendation: {

      recommended: false,

      title: "Focus on the basics first",

      reason:
        "Based on these answers, building a consistent cleanser and moisturizer routine is likely to provide greater benefit than adding a facial oil."

    }

  }

};

window.faceOilResults = {

    needsOil: {

        title: "Highly Recommended",

        confidence: 95,

        description:
            "Based on your answers, your skin would likely benefit from adding a facial oil to your routine.",

        characteristics: [

            "Shows signs of dehydration",

            "Could benefit from additional nourishment",

            "Skin barrier may need extra support"

        ],

        dailyAdvice: [

            "Apply after moisturizer in the evening",

            "Use 2–3 drops",

            "Massage gently into slightly damp skin"

        ],

        commonMistakes: [

            "Using too much product",

            "Applying to dry skin",

            "Expecting overnight results"

        ],

        recommendation: {

            recommended: true,

            product: "Genessence",

            button: "View Genessence",

            url: "/products/genessence",

            reason:
                "Your answers strongly suggest that a lightweight facial oil could improve hydration and support your skin barrier."

        }

    },

    maybeOil: {

        title: "Recommended",

        confidence: 88,

        description:
            "A facial oil could be a valuable addition depending on your goals and current routine.",

        characteristics: [

            "Generally balanced skin",

            "Occasional dehydration",

            "Could benefit from extra nourishment"

        ],

        dailyAdvice: [

            "Use only in the evening",

            "Adjust according to the season",

            "Monitor how your skin responds"

        ],

        commonMistakes: [

            "Applying too much",

            "Changing routines too often"

        ],

        recommendation: {

            recommended: true,

            product: "Genessence",

            button: "View Genessence",

            url: "/products/genessence",

            reason:
                "Based on your answers, a facial oil could complement your routine without replacing your moisturizer."

        }

    },

    doesNotNeedOil: {

        title: "Not Necessary Right Now",

        confidence: 91,

        description:
            "Your routine already covers the essentials well. A facial oil is unlikely to provide significant additional benefits right now.",

        characteristics: [

            "Routine appears balanced",

            "Skin shows few dehydration signs",

            "Current products seem sufficient"

        ],

        dailyAdvice: [

            "Continue using a gentle cleanser",

            "Moisturize consistently",

            "Wear SPF daily"

        ],

        commonMistakes: [

            "Adding unnecessary products",

            "Changing routines too frequently"

        ],

        recommendation: {

            recommended: false,

            title: "No Face Oil Recommended",

            reason:
                "Focus on maintaining a consistent skincare routine before adding additional products."

        }

    }

};